export default __webpack_public_path__ + "static/media/sent-icon.2ed01745.svg";